// src/services/equipmentService.js
import { collection, addDoc, getDocs, doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";

export const equipmentCollectionRef = collection(db, "equipment");

// Add a single equipment item
export const addEquipment = async (equipment) => {
  try {
    const docRef = await addDoc(equipmentCollectionRef, equipment);
    return {
      success: true,
      id: docRef.id
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};

// Get all equipment items
export const getAllEquipment = async () => {
  try {
    const querySnapshot = await getDocs(equipmentCollectionRef);
    const equipment = [];
    
    querySnapshot.forEach((doc) => {
      equipment.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return {
      success: true,
      equipment
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};

// Update an equipment item
export const updateEquipment = async (id, updatedData) => {
  try {
    const equipmentDoc = doc(db, "equipment", id);
    await updateDoc(equipmentDoc, updatedData);
    return {
      success: true
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};

// Delete an equipment item
export const deleteEquipment = async (id) => {
  try {
    const equipmentDoc = doc(db, "equipment", id);
    await deleteDoc(equipmentDoc);
    return {
      success: true
    };
  } catch (error) {
    return {
      success: false,
      error: error.message
    };
  }
};